/**
 * Globalny store dla edit-modal — pozwala TransactionRow w dowolnym miejscu
 * drzewa otworzyć modal bez prop-drilling przez DashboardPage → List → Row.
 */
import { create } from 'zustand';
import type { Transaction } from './transactionsStore';

interface TxModalStore {
  editing: Transaction | null;
  openEdit: (tx: Transaction) => void;
  close: () => void;
}

export const useTxModal = create<TxModalStore>((set) => ({
  editing: null,
  openEdit: (tx) => set({ editing: tx }),
  close: () => set({ editing: null }),
}));
